module.exports = __webpack_public_path__ + "img/PolynomialRegression0.98190587.png";